// Code generated by protoc-gen-weave-ts. DO NOT EDIT.
import * as fm from "../../../../fetch.pb.js";
export const FaxMediaService = {
    /**
     * GetCoversheetTemplate Get a coversheet template by id.
     */
    GetCoversheetTemplate(fn, req) {
        try {
            fm.validateUrlParam(req["id"], "id");
        }
        catch (e) {
            return Promise.reject(e);
        }
        return fn(`/fax/media/v1/templates/${req["id"]}?${fm.renderURLSearchParams(req, ["id"])}`, { method: "GET" });
    },
    /**
     * ListCoversheetTemplate List all the coversheet templates for a location.
     */
    ListCoversheetTemplate(fn, req) {
        return fn(`/fax/media/v1/templates?${fm.renderURLSearchParams(req, [""])}`, { method: "GET" });
    },
    /**
     * UpsertCoversheetTemplate Upsert a coversheet template.
     */
    UpsertCoversheetTemplate(fn, req) {
        return fn(`/fax/media/v1/templates`, { method: "PUT", body: JSON.stringify(req, fm.replacer) });
    },
    /**
     * DeleteCoversheetTemplate Delete a coversheet template by id.
     */
    DeleteCoversheetTemplate(fn, req) {
        try {
            fm.validateUrlParam(req["id"], "id");
        }
        catch (e) {
            return Promise.reject(e);
        }
        return fn(`/fax/media/v1/templates/${req["id"]}?${fm.renderURLSearchParams(req, ["id"])}`, { method: "DELETE" });
    },
    /**
     * GetMediaAttributes Get the size and pages for a list of media ids.
     */
    GetMediaAttributes(fn, req) {
        return fn(`/fax/media/v1/media/attributes?${fm.renderURLSearchParams(req, [""])}`, { method: "GET" });
    },
    /**
     * GenerateMediaAttributes Generates the attributes for a media file if they do not exist.
     * The attributes include the number of pages, size, and thumbnails (small and large).
     */
    GenerateMediaAttributes(fn, req) {
        return fn(`/fax/media/v1/media/attributes`, { method: "POST", body: JSON.stringify(req, fm.replacer) });
    },
    /**
     * RenderCoversheet Renders a coversheet that is being built by the user in the WYSIWYG editor.
     */
    RenderCoversheet(fn, req) {
        return fn(`/fax/media/v1/coversheet/render`, { method: "POST", body: JSON.stringify(req, fm.replacer) });
    },
};
